import { render, staticRenderFns } from "./UnderInvestigation.vue?vue&type=template&id=31e8c4c9"
import script from "./UnderInvestigation.vue?vue&type=script&lang=js"
export * from "./UnderInvestigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports